module.exports = {
      id: "whatsapp-usage",
      viewBox: "0 0 135.081 135.08",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#whatsapp",
      toString: function () {
        return this.url;
      }
    }